import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const styles = {
  container: {
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
  },
};

export default () => {
  const history = useHistory();
  window.close();

  return (
    <div style={styles.container}>
      <Typography align="center">
        Ако не бъдете пренасочени автоматично моля натиснете бутона
      </Typography>
      <Button variant="contained" color="secondary" fullWidth onClick={() => history.push('/')}>
        Начало
      </Button>
    </div>
  );
};
